import { SourceType } from 'module/api/filter/types';
import { useMeetingFieldsAsFilterableField } from 'helpers/fields/meeting-fields/fields';
import { MeetingDetailsSectionComponentProps } from './types';
import { meetingBlockResponseToLookup } from '../../shared/response-renderer-utils';
import { SharedDetailBlockGeneratedSection } from '../shared-detail-blocks/generated-section';

export const MeetingDetailsGeneratedSection = ({
  node,
}: MeetingDetailsSectionComponentProps) => {
  const { fields: meetingFields, loading: isLoading } =
    useMeetingFieldsAsFilterableField();

  return (
    <SharedDetailBlockGeneratedSection
      node={node}
      sourceType={SourceType.Meeting}
      useFieldsHook={() => ({ fields: meetingFields, loading: isLoading })}
      defaultTitleKey="rich_text_editor_sections_meeting_details"
      titlePlaceholderKey="rich_text_editor_sections_meeting_details_title_placeholder"
      fieldLabelKey="grouped_filter.meeting"
      responseToLookupFunction={meetingBlockResponseToLookup}
    />
  );
};
